import React, { useEffect, useState } from "react";
import Base from "./../Base";
import FileUpload from "./../common/FileUpload";
import instance from "../../services/baseService";
import { useDispatch, useSelector } from "react-redux";
import { Collapse } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { HiDownload } from "react-icons/hi";
import { FaCheck, FaCircleDot, FaCircleUser } from "react-icons/fa6";
import toast from "react-hot-toast";
import { GoCommentDiscussion } from "react-icons/go";
import { useParams } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import ChatPopup from "./../common/ChatPopup";
import ViewSheetSummary from './../ViewSheetSummary';
import moment from 'moment';
import { CRUD_PERMISSIONS } from "../../constants/user";
import useCheckAuthorization from "../../hooks/checkAuthorization";
import StepProgressBar from "../common/StepProgressBar";
import { clearNotification } from '../../slices/notificationReducer';
import { getFileIconClass } from '../../utils/fileExtension';
import Loader from "../common/Loader";
import DatePickerComponent from "../DatePickerComponent";
import ImportDrawer from "../common/importBills/ImportDrawer";
import FolderListModal from "../common/importBills/FolderListModal";
import DownloadButton from "../common/DownloadButton";
import { truncateText, truncateTextOnly } from "../../utils";
import useSidebar from "../../hooks/useSidebar";

const Gstr9c = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const [activeSubTab, setActiveSubTab] = useState(0);
  const [rightTab, setRightTab] = useState(0);
  const { selectedMonth, selectedYear } = useSelector((state) => state.common);
  const { selectedStartDate, selectedEndDate } = useSelector((state) => state.common);

  const { isNotificationRoute, notification } = useSelector((state) => state.notification);
  const [loading, setLoading] = useState(false);
  const [summaryFile, setSummaryFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadingBill, setUploadingBill] = useState(false);
  const [sheetData, setSheetData] = useState(null);
  const [sheetSummaryData, setSheetSummaryData] = useState(null);
  const [currentAction, setCurrentAction] = useState({});
  const [summaryData, setSummaryData] = useState([]);
  const [reloadSheet, setReloadSheet] = useState(false);
  const { collapse, expand, isSidebarCollapsed } = useSidebar();

  const [allComments, setAllComments] = useState([]);
  const [file, setFile] = useState(null);
  const [billsData, setBillsData] = useState([]);
  const { client_id } = useParams();
  const manageAllClientsPermission = useCheckAuthorization(CRUD_PERMISSIONS.sheet.manage_clients);

  const tabs = ["Shipping Bill", "Sales Register", "Invoices", "Others"];
  const [approverLevels, setApproverLevels] = useState({});
  const [folderListModalOpen, setFolderListModalOpen] = useState(false);
  const [importedData, setImportedData] = useState(null);
  const section_type = {
    1: "Shipping Bill",
    2: "Sales Register",
    3: "Invoices",
    4: "Others"
  };

  const handleImportResponse = (data) => {
    setImportedData(data);
    collapse();
    setFolderListModalOpen(true)
  };
  const getSheet = async () => {
    try {
      setLoading(true);
      setSheetData(null);
      const res = await instance.post(`/api/v1/client/gstr9c/view/sheet/${client_id}`, {
        start_date: selectedStartDate,
        end_date: selectedEndDate
      });
      if (res.data?.data)
        setSheetSummaryData(res.data?.data);
      setApproverLevels(res.data?.data?.approver_levels);
      setCurrentAction(res.data?.data?.current_action)
      if (res.data?.data?.sheet !== null) {
        setSheetData(res.data?.data?.sheet);
        //setReloadSheet(true);
      }

      setAllComments(res.data?.data?.all_comments);
      setSummaryData(res.data?.data?.summery);

    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };


  const NotePreview = ({ note }) => {
    const [expanded, setExpanded] = useState(false);
    const limit = 50; // Character limit before truncation

    const toggleExpanded = () => setExpanded(!expanded);

    const isLong = note.length > limit;
    const visibleText = expanded ? note : note.slice(0, limit);

    return (
      <div className="bg-green-100 text-green-900 p-3 rounded break-words whitespace-pre-wrap text-sm">
        {visibleText}
        {isLong && (
          <span
            onClick={toggleExpanded}
            className="text-blue-600 cursor-pointer font-semibold ml-2"
          >
            {expanded ? "less" : "...more"}
          </span>
        )}
      </div>
    );
  };



  const submit = async () => {
    setUploadingBill(true);
    setReloadSheet(false);
    try {
      const promise = instance.post(
        `/api/v1/client/gstr9c/upload/sheet/${client_id}`,
        {
          start_date: selectedStartDate,
          end_date: selectedEndDate,
          file: file,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const response = await toast.promise(promise, {
        loading: "Uploading...",
        success: <b>Uploaded!</b>,
        error: <b>Uploading Failed.</b>,
      });
      console.log('response', response);
      if (response.data.type === 'success')
        getSheet();

    } catch (error) {
      console.error("error", error);
    } finally {
      setFile(null);
      setUploadingBill(false);
    }
  };
  // const downloadBillsZip = async (item) => {
  //   try {
  //     const promise = instance.post(
  //       `/api/v1/client/gstr9c/download/zip/${client_id}`,
  //       {
  //         note_id: item.id,
  //       }, {
  //       responseType: 'blob', // Important! Tells axios to handle the response as a blob
  //     }
  //     );
  //     const response = await toast.promise(promise, {
  //       loading: "Downloading...",
  //       success: <b>Downloaded!</b>,
  //       error: <b>Downloading Failed.</b>,
  //     });
  //     // Create a URL for the blob
  //     const url = window.URL.createObjectURL(new Blob([response.data]));

  //     // Create a link element
  //     const link = document.createElement('a');
  //     link.href = url;
  //     const fileName = item.notes.replace(/ /g, "_");
  //     link.setAttribute('download', `${fileName}.zip`); // Specify the filename

  //     // Append to the document and click the link to trigger download
  //     document.body.appendChild(link);
  //     link.click();

  //     // Cleanup
  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("error", error);
  //   } finally {
  //   }
  // }

  // const downloadBillsZip = async (item) => {
  //   try {
  //     const files = item.gstr9c_note_files;

  //     if (!files || files.length === 0) {
  //       toast.error("No files to download");
  //       return;
  //     }

  //     // Show initial toast
  //     const mainToastId = toast.loading(`Starting download of ${files.length} files...`, {
  //       duration: Infinity
  //     });

  //     let completedDownloads = 0;
  //     const totalFiles = files.length;
  //     let currentFileName = '';

  //     // Function to update main progress
  //     const updateMainProgress = (fileName = '', isDownloading = false) => {
  //       const progress = Math.round((completedDownloads / totalFiles) * 100);
  //       const status = isDownloading ? `Downloading: ${fileName}` : `Downloaded ${completedDownloads}/${totalFiles} files`;

  //       toast.loading(
  //         <div>
  //           <div>{status}</div>
  //           <div style={{
  //             width: '200px',
  //             height: '6px',
  //             backgroundColor: '#e5e7eb',
  //             borderRadius: '3px',
  //             marginTop: '8px',
  //             overflow: 'hidden'
  //           }}>
  //             <div style={{
  //               width: `${progress}%`,
  //               height: '100%',
  //               backgroundColor: '#10b981',
  //               transition: 'width 0.3s ease'
  //             }}></div>
  //           </div>
  //           <div style={{ fontSize: '12px', marginTop: '4px' }}>{progress}% complete</div>
  //         </div>,
  //         { id: mainToastId, duration: Infinity }
  //       );
  //     };

  //     // Download each file individually
  //     for (let i = 0; i < files.length; i++) {
  //       const file = files[i];

  //       try {
  //         // Update progress to show current downloading file
  //         updateMainProgress(file.file_name, true);

  //         // Create XMLHttpRequest for download
  //         const downloadPromise = new Promise((resolve, reject) => {
  //           const xhr = new XMLHttpRequest();

  //           xhr.open('GET', file.url, true);
  //           xhr.responseType = 'blob';

  //           xhr.onload = () => {
  //             if (xhr.status === 200) {
  //               resolve(xhr.response);
  //             } else {
  //               reject(new Error(`Failed to download ${file.file_name}`));
  //             }
  //           };

  //           xhr.onerror = () => {
  //             reject(new Error(`Network error downloading ${file.file_name}`));
  //           };

  //           xhr.send();
  //         });

  //         // Wait for download to complete
  //         const blob = await downloadPromise;

  //         // Create download link and trigger download
  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', file.file_name);

  //         // Trigger download
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);

  //         // Cleanup blob URL
  //         window.URL.revokeObjectURL(url);

  //         completedDownloads++;
  //         updateMainProgress();

  //         // Small delay between downloads to prevent overwhelming the browser
  //         if (i < files.length - 1) {
  //           await new Promise(resolve => setTimeout(resolve, 500));
  //         }

  //       } catch (fileError) {
  //         console.error(`Error downloading ${file.file_name}:`, fileError);

  //         // Still count as processed for progress
  //         completedDownloads++;
  //         updateMainProgress();
  //       }
  //     }

  //     // Final success message
  //     toast.success(
  //       <div>
  //         <div><b>All downloads completed!</b></div>
  //         <div style={{ fontSize: '12px', marginTop: '2px' }}>
  //           {completedDownloads} files downloaded successfully
  //         </div>
  //       </div>,
  //       { id: mainToastId, duration: 4000 }
  //     );

  //   } catch (error) {
  //     console.error("Error in download process:", error);
  //     toast.error("Download process failed");
  //   }
  // };

  const downloadBillsZip = async (item) => {
    try {
      // Check the flag to determine which logic to use
      if (item.push_to_preface === 0) {
        // Original ZIP download logic
        const promise = instance.post(
          `/api/v1/client/gstr9c/download/zip/${client_id}`,
          {
            note_id: item.id,
          }, {
          responseType: 'blob', // Important! Tells axios to handle the response as a blob
        }
        );

        const response = await toast.promise(promise, {
          loading: "Downloading...",
          success: <b>Downloaded!</b>,
          error: <b>Downloading Failed.</b>,
        });

        // Create a URL for the blob
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        const fileName = item.notes.replace(/ /g, "_");
        link.setAttribute('download', `${fileName}.zip`); // Specify the filename

        // Append to the document and click the link to trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

      } else if (item.push_to_preface === 1) {
        // Individual file download logic with progress and folder selection
        const files = item.gstr9c_note_files;

        if (!files || files.length === 0) {
          toast.error("No files to download");
          return;
        }

        // Show folder picker first
        let directoryHandle = null;
        if (window.showDirectoryPicker) {
          try {
            directoryHandle = await window.showDirectoryPicker();
          } catch (error) {
            if (error.name === 'AbortError') {
              return; // User cancelled
            }
          }
        }

        // Show initial toast
        const mainToastId = toast.loading(`Starting download of ${files.length} files...`, {
          duration: Infinity
        });

        let completedDownloads = 0;
        const totalFiles = files.length;

        // Function to update main progress
        const updateMainProgress = (fileName = '', isDownloading = false) => {
          const progress = Math.round((completedDownloads / totalFiles) * 100);
          const status = isDownloading ? `Downloading: ${fileName}` : `Downloaded ${completedDownloads}/${totalFiles} files`;

          toast.loading(
            <div>
              <div>{status}</div>
              <div style={{
                width: '200px',
                height: '6px',
                backgroundColor: '#e5e7eb',
                borderRadius: '3px',
                marginTop: '8px',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: `${progress}%`,
                  height: '100%',
                  backgroundColor: '#10b981',
                  transition: 'width 0.3s ease'
                }}></div>
              </div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>{progress}% complete</div>
            </div>,
            { id: mainToastId, duration: Infinity }
          );
        };

        // Download each file individually
        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          try {
            updateMainProgress(file.file_name, true);

            if (directoryHandle) {
              // Save to selected folder using File System Access API
              const response = await fetch(file.url);
              const blob = await response.blob();

              const fileHandle = await directoryHandle.getFileHandle(file.file_name, { create: true });
              const writable = await fileHandle.createWritable();
              await writable.write(blob);
              await writable.close();
            } else {
              // Fallback to default browser download method
              const downloadPromise = new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', file.url, true);
                xhr.responseType = 'blob';

                xhr.onload = () => {
                  if (xhr.status === 200) {
                    resolve(xhr.response);
                  } else {
                    reject(new Error(`Failed to download ${file.file_name}`));
                  }
                };

                xhr.onerror = () => {
                  reject(new Error(`Network error downloading ${file.file_name}`));
                };

                xhr.send();
              });

              const blob = await downloadPromise;
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', file.file_name);

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }

            completedDownloads++;
            updateMainProgress();

            // Small delay between downloads to prevent overwhelming the browser
            if (i < files.length - 1) {
              await new Promise(resolve => setTimeout(resolve, 500));
            }

          } catch (fileError) {
            console.error(`Error downloading ${file.file_name}:`, fileError);

            // Still count as processed for progress
            completedDownloads++;
            updateMainProgress();
          }
        }

        // Final success message
        toast.success(
          <div>
            <div><b>All downloads completed!</b></div>
            <div style={{ fontSize: '12px', marginTop: '2px' }}>
              {completedDownloads} files downloaded successfully
            </div>
          </div>,
          { id: mainToastId, duration: 4000 }
        );
      } else {
        // Handle unexpected flag values
        toast.error("Invalid download configuration");
        console.error("Invalid push_to_preface flag value:", item.push_to_preface);
      }

    } catch (error) {
      console.error("Error in download process:", error);
      toast.error("Download process failed");
    }
  };

  const getAllGstFiles = async () => {
    try {
      const res = await instance.post(
        `/api/v1/client/gstr9c/list/files/${client_id}`,
        {
          start_date: selectedStartDate,
          end_date: selectedEndDate,
          section_type: activeTab,
        }
      );
      console.log(res);
      const data = res.data?.data?.list?.map((item) => ({
        key: item?.id,
        label: (
          <p className="font-semibold text-base flex items-start gap-x-2">
            {" "}
            <span className="bg-[#0f4372] text-white rounded-full p-px px-2">
              {item.gstr9c_note_files?.length}
            </span>
            <div className="flex flex-col">
              {truncateTextOnly(item.notes ? item.notes : "Summary", 25)}
              <span className="text-xs font-normal">{moment(item?.updated_date).format('DD-MM-YYYY')}</span>
            </div>
          </p>
        ),
        section: item?.section,
        children: (
          <div>
            <div class="pfa-down-all"><a class="badge badge-success1" href="#" onClick={() => downloadBillsZip(item)}>Download all <i class="las la-download"></i></a></div>
            <ul className="divide-y">
              {item?.gstr9c_note_files?.map((file, i) => (
                <li
                  key={i}
                  className="flex justify-between uppercase py-3 text-[#0f4372]"
                >
                  {file?.file_name}{" "}
                  <DownloadButton file={file} client_id={client_id} section="GSTR9C" />
                </li>
              ))}
            </ul>
            {/* {item.notes && (
              <p className="pa-acc-notes alert alert-success">{truncateText(item.notes ? item.notes : "Summary", 25)}</p>
            )} */}
            {item.notes && (
              <p>{item.notes && <NotePreview note={item.notes} />}</p>
            )}
          </div>
        ),
      }));
      setBillsData(data);
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleSummaryFileChange = (files) => {
    const selectedFiles = Array.from(files); // Convert FileList to array
    setSummaryFile(selectedFiles);
    uploadSummaryFiles(selectedFiles);
  };

  const uploadSummaryFiles = async (files) => {
    setUploading(true);
    const formData = new FormData();
    files.forEach((fileSingle) => {
      formData.append("files", fileSingle);
    });
    formData.append("start_date", selectedStartDate);
    formData.append("end_date", selectedEndDate);
    try {
      const promise = instance.post(
        `/api/v1/client/gstr9c/add/ar/${client_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const res = await toast.promise(promise, {
        loading: "Uploading...",
        success: <b>Uploaded!</b>,
        error: <b>Uploading Failed.</b>,
      });
      getSheet();
    } catch (error) {
      console.log(error);
      console.log(error);
      if (error?.response?.data?.message) {
        toast(error?.response?.data?.message);
      }
    } finally {
      setSummaryFile(null);
      setUploading(false);
    }
  };

  const handleSummaryApprove = async (id, status) => {
    setLoading(true);
    try {
      const promise = instance.post(
        `/api/v1/client/gstr9c/summery/approve/${client_id}/${id}`,
        {
          start_date: selectedStartDate,
          end_date: selectedEndDate,
          approve: status,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await toast.promise(promise, {
        loading: "Submitting...",
        success: (response) => <b>{response.data.message || "Summary Submitted Successfully!"}</b>,
        error: (error) => <b>{error.response?.data?.message || "Submission Failed."}</b>,
      });
      getSheet();

    } catch (error) {
      console.error("error", error);
      if (error?.response?.data?.message) {
        //toast(error?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  }

  const sheetSubmitAction = async (sheetId, status, roleId) => {
    setLoading(true);
    try {
      const requestBody = {
        start_date: selectedStartDate,
        end_date: selectedEndDate,
        approve: status,
      };
      if (roleId) {
        requestBody.next_level = roleId;
      }
      const promise = instance.post(
        `/api/v1/client/gstr9c/gst/approve/${client_id}`,
        requestBody,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await toast.promise(promise, {
        loading: "Submitting...",
        success: <b>Submitted Successfully!</b>,
        error: <b>Submission Failed.</b>,
      });
      getSheet();

    } catch (error) {
      console.error("error", error);
      if (error?.response?.data?.message) {
        toast(error?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  }

  const handleSheetSubmitManager = async (sheetId, status) => {
    setLoading(true);
    try {
      const promise = instance.post(
        `/api/v1/client/gstr9c/gst/manager/approve/${client_id}/${sheetId}`,
        {
          start_date: selectedStartDate,
          end_date: selectedEndDate,
          approve: status,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await toast.promise(promise, {
        loading: "Submitting...",
        success: <b>Submitted Successfully!</b>,
        error: <b>Submission Failed.</b>,
      });
      getSheet();

    } catch (error) {
      console.error("error", error);
      if (error?.response?.data?.message) {
        toast(error?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  }

  const hadleDeleteSheet = async (sheetId) => {
    try {
      setLoading(true);
      const promise = instance.post(`/api/v1/client/gstr9c/delete/sheet/${client_id}`, {
        sheet_id: sheetId,
      });
      const response = await toast.promise(promise, {
        loading: "Deleting...",
        success: <b>Deleted!</b>,
        error: <b>Deleting Failed.</b>,
      });
      getSheet();


    } catch (error) {
      console.error('error', error);
    } finally {
      setLoading(false);
    }
  }

  const handleSkipSubmit = async (roleId) => {
    sheetSubmitAction(null, null, roleId);
  };

  useEffect(() => {
    if (file) {
      submit();
      console.log("file", file);
    }
  }, [file]);

  useEffect(() => {
    if (activeTab === 1 || activeTab === 2 || activeTab === 3 || activeTab === 4 || activeTab === 5)
      getAllGstFiles();
  }, [selectedStartDate, selectedEndDate, activeTab, activeSubTab]);

  useEffect(() => {
    if (activeTab === 0) getSheet();
  }, [selectedStartDate, selectedEndDate, activeTab]);

  useEffect(() => {
    if (isNotificationRoute) {
      dispatch(clearNotification());
      getSheet();
    }
  }, [isNotificationRoute]);

  const customExpandIcon = ({ isActive }) => {
    return isActive ? <MinusOutlined size={36} /> : <PlusOutlined size={36} />;
  };

  function formatMonthYear(mmYYYY) {
    if (!mmYYYY) return '';
    const [mm, yyyy] = mmYYYY.split('-');
    // month is 0-based in Date()
    const date = new Date(Number(yyyy), Number(mm) - 1);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }

  return (
    <Base hideDatepicker={true} header_title="GSTR - 9C">
      {loading ? (
        <Loader />
      ) : (
        <>
          <DatePickerComponent hideDatepicker={false} title="Reports" submitFunction={() => (activeTab === 0 ? getSheet() : getAllGstFiles())} />
          <div className="bg-white shadow-sm rounded-2xl w-full h-full px-3 py-4 space-x-3">
            <div className="mb-3">
              <span
                onClick={() => setActiveTab(0)}
                className={`${activeTab === 0 ? "bg-[#F37920] text-white" : ""
                  } cursor-pointer p-2 px-3 rounded-full relative`}
              >
                Others
                {activeTab === 0 && (
                  <div className=" absolute w-0 h-0 left-7 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                )}
              </span>
              {/* <span
                onClick={() => setActiveTab(1)}
                className={`${activeTab === 1 ? "bg-[#F37920] text-white" : ""
                  } cursor-pointer p-2 px-3 rounded-full relative`}
              >
                Financial statements
                {activeTab === 1 && (
                  <div className=" absolute w-0 h-0 left-14 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                )}
              </span>

              <span
                onClick={() => setActiveTab(2)}
                className={`${activeTab === 2 ? "bg-[#F37920] text-white" : ""
                  } cursor-pointer p-2 px-3 rounded-full relative`}
              >
                Budgeting and Forecasting
                {activeTab === 2 && (
                  <div className=" absolute w-0 h-0 left-14 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                )}
              </span>

              <span
                onClick={() => setActiveTab(3)}
                className={`${activeTab === 3 ? "bg-[#F37920] text-white" : ""
                  } cursor-pointer p-2 px-3 rounded-full relative`}
              >
                Ratio Analysis
                {activeTab === 3 && (
                  <div className=" absolute w-0 h-0 left-14 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                )}
              </span>

              <span
                onClick={() => setActiveTab(4)}
                className={`${activeTab === 4 ? "bg-[#F37920] text-white" : ""
                  } cursor-pointer p-2 px-3 rounded-full relative`}
              >
                KPI
                {activeTab === 4 && (
                  <div className=" absolute w-0 h-0 left-5 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                )}
              </span>

              <span
                onClick={() => setActiveTab(5)}
                className={`${activeTab === 5 ? "bg-[#F37920] text-white" : ""
                  } cursor-pointer p-2 px-3 rounded-full relative`}
              >
                Stock statement
                {activeTab === 5 && (
                  <div className=" absolute w-0 h-0 left-14 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                )}
              </span> */}

            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <span
                style={{
                  backgroundColor: '#FFE5B4', // light orange
                  color: '#F37920',           // dark orange
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontWeight: '500',
                }}
              >
                {formatMonthYear(selectedStartDate)}
                &nbsp;–&nbsp;
                {formatMonthYear(selectedEndDate)}
              </span>
            </div>
            {activeTab === 0 ? (
              <div>
                {sheetData && approverLevels.length > 0 && (
                  <StepProgressBar approverLevels={approverLevels} />
                )}
                <h1 className="text-xl flex gap-x-2 items-center mb-4">
                  <img
                    className="w-10"
                    src="../assets/icons/up-loading.png"
                    alt="Upload Icon"
                  />
                  Upload summary for client approval
                </h1>

                {/* Two FileUpload components side by side */}
                <div className="flex flex-col lg:flex-row gap-6 mb-6">
                  {/* First FileUpload Section */}
                  <div className="bg-white rounded-lg border p-4 lg:w-3/4 w-full">
                    <div className="mb-3">
                      <h3 className="text-lg font-semibold mb-2">Reports Form Upload</h3>
                      <div className="mb-3 text-sm text-gray-600">
                        Upload Reports form here (Single sheet excel file only allowed)
                      </div>
                      {uploadingBill ? (
                        <div className="text-center py-4">Uploading...</div>
                      ) : (
                        <FileUpload
                          file={file}
                          setFile={setFile}
                          inputId="bills"
                          allowMultiple={false}
                        />
                      )}
                    </div>

                    {/* Content under first FileUpload */}
                    <div className="mt-4">
                      <div className="w-full overflow-x-auto">
                        {!sheetData ? (
                          <h4 className="text-center mt-4 text-gray-500">
                            No Summary Uploaded For the period !
                          </h4>
                        ) : (
                          <ViewSheetSummary
                            sheetSummaryData={sheetSummaryData}
                            handleSheetSubmit={sheetSubmitAction}
                            handleSheetSubmitManager={handleSheetSubmitManager}
                            sheetType="gstr9c"
                            getSheet={getSheet}
                            hadleDeleteSheet={hadleDeleteSheet}
                            approverLevels={approverLevels}
                            currentAction={currentAction}
                            handleSkipSubmit={handleSkipSubmit}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Second FileUpload Section */}
                  <div className="bg-[#fafafa] rounded-lg border p-4 lg:w-1/4 w-full">
                    <div className="mb-3">
                      <h3 className="text-lg font-semibold mb-2">Upload Summary</h3>
                      <div className="mb-3 text-sm text-gray-600">
                        Upload Reports workings and summary (PDF or Excel files)
                      </div>
                      {uploading ? (
                        <div className="text-center py-4">Uploading...</div>
                      ) : (
                        <FileUpload
                          file={summaryFile}
                          setFile={handleSummaryFileChange}
                          inputId="summary"
                          allowMultiple={true}
                        />
                      )}
                    </div>

                    {/* Content under second FileUpload */}
                    <div className="mt-4">
                      {/* Tab Navigation */}
                      <div className="mb-4">
                        <span
                          onClick={() => {
                            setRightTab(0);
                            getSheet();
                          }}
                          className={`${rightTab === 0 ? "bg-[#F37920] text-white" : "bg-gray-200 text-gray-700"
                            } text-xs cursor-pointer p-2 px-3 rounded-full relative mr-2 inline-block`}
                        >
                          Download
                          {rightTab === 0 && (
                            <div className="absolute w-0 h-0 left-10 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                          )}
                        </span>
                        <span
                          onClick={() => {
                            setRightTab(1);
                            getSheet();
                          }}
                          className={`${rightTab === 1 ? "bg-[#F37920] text-white" : "bg-gray-200 text-gray-700"
                            } text-xs cursor-pointer p-2 px-3 rounded-full relative inline-block`}
                        >
                          Comments
                          {rightTab === 1 && (
                            <div className="absolute w-0 h-0 left-14 -bottom-2 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-[#F37920]"></div>
                          )}
                        </span>
                      </div>

                      {/* Tab Content */}
                      {rightTab === 0 ? (
                        <div className="max-h-80 overflow-y-auto">
                          <ul className="list-group list-group-flush r-list-group r-list-group-icon space-y-2">
                            {summaryData?.map((summary) => {
                              const fileIconClass = getFileIconClass(summary.file_name);
                              return (
                                <li key={summary.id} className="list-group-item bg-white rounded border p-3">
                                  <a
                                    href={summary.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="flex items-center text-blue-600 hover:text-blue-800 mb-2"
                                  >
                                    <i className={`${fileIconClass} mx-2 px-1`}></i>
                                    <span className="break-all">{summary.file_name}</span>
                                  </a>
                                  <small className="text-[#212529] block mb-2">
                                    {moment(summary.updated_date).format("DD-MM-YYYY hh:mm:ss A")}
                                  </small>
                                  <div className="flex flex-wrap items-center gap-2">
                                    {summary.preface_approval === 1 && (
                                      <Badge bg="primary">Approved</Badge>
                                    )}
                                    {summary.preface_approval === 2 && (
                                      <Badge bg="light">Rejected</Badge>
                                    )}
                                    {!manageAllClientsPermission && summary.preface_approval === 0 && (
                                      <Badge bg="warning">Waiting</Badge>
                                    )}
                                    {manageAllClientsPermission && summary.preface_approval === 0 && (
                                      <>
                                        <Button
                                          variant="primary"
                                          size="sm"
                                          className="py-0 px-1 !text-[12px]"
                                          onClick={() => handleSummaryApprove(summary.id, 1)}
                                        >
                                          Approve
                                        </Button>
                                        <Button
                                          variant="outline-primary"
                                          size="sm"
                                          className="py-0 px-1 !text-[12px]"
                                          onClick={() => handleSummaryApprove(summary.id, 2)}
                                        >
                                          Reject
                                        </Button>
                                      </>
                                    )}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ) : (
                        <div className="flex flex-col overflow-y-auto max-h-80 divide-y mt-5">
                          {allComments?.map((comment) => (
                            <p
                              key={comment.id}
                              className={`hover:bg-[#f1f1f1] text-xs flex flex-col m-0 items-start gap-x-2 py-3 px-2 rounded-md cursor-pointer ${comment.status !== 4 ? "justify-between" : ""
                                }`}
                            >
                              <div className="flex w-full items-center gap-x-2">
                                {comment.status === 4 ? (
                                  <FaCircleUser size={18} color="#fcbba5" />
                                ) : (
                                  <GoCommentDiscussion size={18} color="#fcbba5" />
                                )}
                                <span className="flex-1 break-words">{comment.comment}</span>
                                {comment.status && (
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={
                                      <Tooltip id={`button-tooltip-${comment.id}`}>
                                        {comment.status === 1 && "Approved"}
                                        {comment.status === 2 && "Rejected"}
                                        {comment.status === 4 && "Resolved"}
                                      </Tooltip>
                                    }
                                    container={document.body}
                                  >
                                    <span
                                      id={`button-tooltip-${comment.id}`}
                                      className="ml-auto"
                                    >
                                      <FaCircleDot
                                        className={`${comment.status === 1 && "text-success"
                                          } ${comment.status === 4 && "text-success"} ${comment.status === 2 && "text-danger"
                                          }`}
                                      />
                                    </span>
                                  </OverlayTrigger>
                                )}
                              </div>
                              <div className="mt-1 text-gray-600 w-full">
                                <span className="text-xs">
                                  Added by: {comment.created_user_profile?.name || comment.created_user_profile?.email}
                                </span>
                              </div>
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {/* <div className="flex gap-x-3 -mb-8">
                  {tabs.map((tab, i) => (
                    <p
                      key={i}
                      className={`${activeSubTab === i ? "bg-[#333333] text-white" : ""
                        } flex items-center gap-x-2 rounded-ss-md rounded-se-md px-2 py-1 cursor-pointer hover:bg-[#333333] hover:text-white`}
                      onClick={() => setActiveSubTab(i)}
                    >
                      {tab}
                      {activeSubTab === i && (
                        <span className="bg-green-500 text-white h-fit rounded-full p-px">
                          <FaCheck />
                        </span>
                      )}
                    </p>
                  ))}
                </div> */}
                <hr className="border-blue-500 mb-5" />
                <div className="bg-[#fafafa] p-4 rounded-lg">
                  <h1 className="text-xl mb-3 flex items-center gap-x-2">
                    {" "}
                    <img
                      className="w-10"
                      src="../assets/icons/downloading.png"
                      alt="Upload Icon"
                    />{" "}
                    {activeTab === 1
                      ? "Download Financial statements"
                      : activeTab === 2
                        ? "Download Budgeting and Forecasting"
                        : activeTab === 3
                          ? "Download Ratio Analysis"
                          : activeTab === 4
                            ? "Download KPI"
                            : activeTab === 5
                              ? "Download Stock statement"
                              : "Download"}
                  </h1>
                  <Collapse
                    accordion
                    items={billsData}
                    expandIcon={customExpandIcon}
                    expandIconPosition={"end"}
                  />
                </div>
              </div>
            )}
          </div>
          <ChatPopup client_id={client_id} chat_type="GSTR9C" />
          {/* <ImportDrawer onImport={handleImportResponse} folder_id={null} gstrFormName="gstr9c" /> */}
          {importedData && (
            <FolderListModal
              show={folderListModalOpen}
              onHide={() => { setFolderListModalOpen(false); expand(); }}
              client_id={client_id}
              folder_id={null}
              data={importedData}
              gstrFormName="gstr9c"
              start_date={selectedStartDate}
              end_date={selectedEndDate}
              subCategories={section_type}
              onSubmitSuccess={res => console.log('Submitted:', res)}
            />
          )}
        </>
      )}
    </Base>
  );
};

export default Gstr9c;
